import { useState } from "react";
import { UI_CONFIG } from "../constants/index";

export default function EmailForm({ onSubmit, isLoading }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email.trim()) {
      setError("Veuillez entrer votre email");
      return;
    }

    if (!email.endsWith('@eleve.isep.fr')) {
      setError("Veuillez entrer un email Isep valide (@eleve.isep.fr)");
      return;
    }

    try {
      await onSubmit(email);
    } catch (err) {
      // console.log('🚨 Error caught in EmailForm:', err);
      // console.log('🚨 Error message:', err.message);
      if (err.message && err.message.includes("déjà tourné")) {
        setError("⚠️ " + err.message);
      } else {
        setError(err.message || "Une erreur s'est produite");
      }
    }
  };

  const renderHeader = () => (
    <div className="flex items-center pb-8">
      <div className={`${UI_CONFIG.LOGO_SIZE.MEDIUM}`}>
        <img 
          src="/static/juniorisep.svg" 
          alt="Logo" 
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );

  const renderForm = () => (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1 text-left text-[13px] font-bold">
          Adresse email Isep
        </label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-colors text-base bg-white shadow-sm hover:shadow-md text-[11px]"
          placeholder="prénom.nom@eleve.isep.fr"
          required
          disabled={isLoading}
        />
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-xl p-4">
          <p className="text-red-600 text-sm">{error}</p>
        </div>
      )}

      <button
        type="submit"
        disabled={isLoading}
        className="w-full bg-gradient-to-r from-orange-500 to-yellow-500 text-white font-semibold py-4 px-8 rounded-lg hover:from-orange-600 hover:to-yellow-600 transition-all duration-300 transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl text-[13px] font-bold"
      >
        {isLoading ? (
          <div className="flex items-center justify-center">
            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
            Vérification...
          </div>
        ) : (
          "Continuer"
        )}
      </button>
    </form>
  );

  return (
    <div className="px-4 md:px-10 w-full h-screen bg-white flex flex-col overflow-hidden">
      <div className="flex-1 flex flex-col justify-center overflow-y-auto">
        {renderHeader()}

        <div className="flex-1 flex flex-col justify-center max-w-lg mx-auto">
          <div className="mb-4">
            <h1 className="text-xl md:text-4xl font-bold text-gray-900 mb-1 leading-tight text-left">
              C'est parti
            </h1>
            <p className="text-base text-[12px] text-gray-600 leading-relaxed text-left">
              Entre ton email pour tenter ta chance
            </p>
          </div>

          {renderForm()}
        </div>
      </div>
    </div>
  );
}
